import React, {useLayoutEffect, useState} from 'react';
import {withRouter} from "react-router-dom";
import Breadcrumbs from './components/breadcrumbs';
import {useTranslation} from 'react-i18next';
import {dropDownPosition} from '../../../../../../utils';
import DropDown from '../../../../../../components/dropdown';
import DropDownItem from '../../../../../../components/dropdown/components/dropdown-item';
import {useDispatch, useSelector} from 'react-redux';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import AiButton from '../../../../../../components/ai-button';
import Button from '../../../../../../components/button';
import {isContactWithAiPopupShown} from '../../../../../../../actions/popupActions';

function ListOfContactsHeader () {

	const [dropDown, setDropDown] = useState(false);

	const selectedContactsGroup = useSelector( state => state.contactsGroupItemReducer.getSelectedContactsGroup);

	const { t } = useTranslation();
	const dispatch = useDispatch();

	useLayoutEffect(() => {
		if(dropDown){
			dropDownPosition(
				document.querySelector('.list-of-contacts-header'),
				document.querySelector('.list-of-contacts-header .add-button'),
				document.querySelector('.list-of-contacts-header .drop-down'),
			);
		}
	}, [dropDown]);

	const handleClick = () => {
		setDropDown(true);
	};

	const handleExistingContact = () => {
		dispatch(getSharingDetailsPopup([true, 'add_existing_contact_to_label']));
	};

	return (
		<div className="list-of-contacts-header border-bottom d-flex align-items-center p-3 position-relative overflow-hidden">
			<Breadcrumbs/>
			<AiButton disabled={ selectedContactsGroup.permission === "READ_ONLY" || selectedContactsGroup.type === "directory" || selectedContactsGroup.type === "childDirectory" || selectedContactsGroup.type === "childDirectoryLv2"} onClick={ () => { window.webful?.track('ai_contact_clicked', { tab: 'voice' }); dispatch(isContactWithAiPopupShown({action:'create', tab:'voice'})); }  } className="ml-auto">
				{t('addContactWithAiBtn')}
			</AiButton>
			{
				selectedContactsGroup && <Button className="btn-primary add-button ml-2 text-truncate" disabled={ selectedContactsGroup.permission === "READ_ONLY" || selectedContactsGroup.type === "directory" || selectedContactsGroup.type === "childDirectory" || selectedContactsGroup.type === "childDirectoryLv2"} onClick={ handleClick } title={t("textCreateContact")}>
					<svg
						fill="none"
						viewBox="0 0 16 16"
						role="presentation"
						className="mr-2"
						width={16}
					>
						<path
							fill="currentcolor"
							fillRule="evenodd"
							d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z"
							clipRule="evenodd"
						/>
					</svg>
					{t('labelContextMenuAddContact')}
				</Button>
			}
			{
				dropDown && <DropDown onClick={handleClick} onMouseLeave={() => setDropDown(false)}>
					<DropDownItem
						link={'/label/new-contact'}
						picto={
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<path
									fill="currentColor"
									d="M18.545 14.182v-3.273h-3.272V8.727h3.272V5.455h2.182v3.272H24v2.182h-3.273v3.273zM8.727 12q-1.8 0-3.082-1.282-1.281-1.281-1.281-3.082t1.281-3.081q1.282-1.282 3.082-1.282t3.082 1.282 1.282 3.081-1.282 3.082Q10.528 12 8.727 12M0 20.727v-3.054q0-.927.477-1.705a3.2 3.2 0 0 1 1.268-1.186 16 16 0 0 1 3.437-1.268 15 15 0 0 1 3.545-.423q1.8 0 3.546.423 1.745.422 3.436 1.268.79.41 1.268 1.186a3.2 3.2 0 0 1 .478 1.705v3.054zm2.182-2.182h13.091v-.872q0-.3-.15-.546a1.07 1.07 0 0 0-.396-.382 14.2 14.2 0 0 0-2.972-1.104 12.6 12.6 0 0 0-6.055 0q-1.5.368-2.973 1.104a1.1 1.1 0 0 0-.395.382q-.15.246-.15.546zm6.545-8.727q.9 0 1.541-.641.64-.64.641-1.541 0-.9-.641-1.541a2.1 2.1 0 0 0-1.541-.64 2.1 2.1 0 0 0-1.541.64 2.1 2.1 0 0 0-.641 1.541q0 .9.641 1.541.64.642 1.541.641m0 8.727"
									style={{
										strokeWidth: 1,
									}}
								/>
							</svg>
						}
						title={t("createNewContactText")}
					/>
					{
						selectedContactsGroup.type !== 'system' && <DropDownItem
							onClick={handleExistingContact}
							picto={
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path
										fill="currentColor"
										d="M3.273 24v-2.182h17.454V24zm0-21.818V0h17.454v2.182zM12 13.091q1.364 0 2.318-.955.955-.954.955-2.318T14.318 7.5A3.16 3.16 0 0 0 12 6.545q-1.364 0-2.318.955-.955.954-.955 2.318t.955 2.318 2.318.955m-8.727 7.636q-.9 0-1.541-.641a2.1 2.1 0 0 1-.641-1.541V5.454q0-.9.641-1.54a2.1 2.1 0 0 1 1.541-.641h17.454q.9 0 1.541.641a2.1 2.1 0 0 1 .641 1.54v13.091q0 .9-.641 1.541a2.1 2.1 0 0 1-1.541.641zm1.909-2.182a8.85 8.85 0 0 1 2.973-2.4Q9.9 15.273 12 15.273t3.845.872a8.85 8.85 0 0 1 2.973 2.4h1.909V5.454H3.273v13.091zm3.218 0h7.2a6 6 0 0 0-1.705-.818A6.6 6.6 0 0 0 12 17.455q-.982 0-1.895.272a6 6 0 0 0-1.705.818m3.6-7.636q-.463 0-.777-.314a1.06 1.06 0 0 1-.314-.777q0-.463.314-.777.313-.314.777-.314.463 0 .777.314t.314.777-.314.777a1.06 1.06 0 0 1-.777.314M12 12"
										style={{
											strokeWidth: 1,
										}}
									/>
								</svg>
							}
							title={t("addToExistingContact")}
						/>

					}
					<DropDownItem
						onClick={() => { window.webful?.track('ai_contact_clicked', { tab: 'voice' }); dispatch(isContactWithAiPopupShown({action:'create', tab:'voice'})); }}
						picto={
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<path
									fill="currentColor"
									d="M12 15.157q-1.579.002-2.685-1.104-1.105-1.105-1.105-2.685V3.79q0-1.579 1.105-2.685Q10.42 0 12 0t2.684 1.105Q15.79 2.21 15.789 3.79v7.579c0 1.054-.367 1.946-1.105 2.685Q13.579 15.158 12 15.157M10.736 24v-3.885q-3.284-.44-5.432-2.938-2.147-2.493-2.147-5.81h2.526q0 2.62 1.847 4.47 1.849 1.846 4.468 1.846 2.62 0 4.469-1.847 1.85-1.848 1.848-4.469h2.525q0 3.316-2.148 5.81-2.146 2.497-5.43 2.938V24zM12 12.631q.537 0 .901-.363a1.23 1.23 0 0 0 .363-.899V3.79q-.001-.537-.365-.901-.365-.364-.899-.363c-.534.001-.657.122-.9.364a1.2 1.2 0 0 0-.363.899v7.579q0 .538.364.9.363.364.899.363"/>
							</svg>
						}
						title={t("dictateNewContact")}
					/>
					<DropDownItem
						onClick={() => { window.webful?.track('ai_contact_clicked', { tab: 'image' }); dispatch(isContactWithAiPopupShown({action:'create', tab:'image'})); }}
						picto={
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<path
									fill="currentColor"
									d="M1.091 5.455V0h5.454v2.182H3.273v3.272H1.091zm19.636 0V2.182h-3.272V0h5.455v5.455zM1.091 24v-5.454h2.182v3.271h3.272V24zm16.363 0v-2.183h3.272v-3.271h2.183V24zM6.545 18.546h10.909V5.455H6.545zm0 2.181a2.1 2.1 0 0 1-1.541-.641 2.1 2.1 0 0 1-.641-1.54V5.455q0-.9.641-1.541a2.1 2.1 0 0 1 1.541-.641h10.909q.9 0 1.542.641.64.642.641 1.541v13.091q0 .899-.641 1.54a2.1 2.1 0 0 1-1.542.641zM8.728 9.818h6.545V7.637H8.728zm0 3.273h6.545v-2.182H8.728zm0 3.272h6.545v-2.181H8.728zm-2.183 2.183V5.455z"/>
							</svg>
						}
						title={t("scanImage")}
					/>
				</DropDown>
			}
		</div>
	)
}

export default withRouter(ListOfContactsHeader);
